import Vue from "vue";
import VueRouter from "vue-router";
import Game from "../views/Game";
import GameExplanation from "../views/GameExplanation";
import Gameover from "../views/Gameover";
import GameCountdown from "../views/GameCountdown";
import FeedbackPage from "../views/Feedback";
import Setup from "../views/Setup";

export const routesName = {
  setup: "/",
  gameExplanation: "/gameExplanation",
  countdown: "/countdown",
  game: "/game",
  gameOver: "/gameover",
  feedback: "/feedback",
};

const routes = [
  {
    path: routesName.gameExplanation,
    component: GameExplanation,
    meta: { transitionName: "slide", id: 0 },
  },
  {
    path: routesName.setup,
    component: Setup,
    meta: { transitionName: "slide", id: 0 },
  },
  {
    path: routesName.countdown,
    component: GameCountdown,
    meta: { transitionName: "slide", id: 1 },
  },
  {
    path: routesName.game,
    component: Game,
    meta: { transitionName: "slide", id: 2 },
  },
  {
    path: routesName.gameOver,
    component: Gameover,
    meta: { transitionName: "slide", id: 3 },
  },
  {
    path: routesName.feedback,
    component: FeedbackPage,
    meta: { transitionName: "slide", id: 4 },
  },
];

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
